import * as PIXI from "pixi.js";
import InfoSlider from "./InfoSlider";
import InfoPage from "./InfoPage";
import SlideAnimation from "../../animation/SlideAnimation";
import TextureManager from "../../managers/TextureManager";
import { rootEventBus, EnumRootEventBus } from "../../managers/RootEventBus";
import { Dims } from "../../types/Interface";

const MASK_PATH = "/info-slider/mask.png";

export default class InfoSliderBody extends PIXI.Container {
  private InfoSlider: InfoSlider = InfoSlider.getInstance();
  private Pages: PIXI.Container;
  private currPageIndex = 0;
  private infoSliderDims: Dims;
  private infoSliderAssets: string[];
  constructor(infoSliderAssets: string[], infoSliderDims: Dims) {
    super();
    this.infoSliderAssets = infoSliderAssets
    this.infoSliderDims = infoSliderDims;
    this.addPages();
    this.addMask();
    this.addFrame();
    this.addToCon();
    this.calcBoundaryStatus()

    rootEventBus.on(EnumRootEventBus.setInfoSliderPage, pNumber => this.setPage(pNumber));
    rootEventBus.on(EnumRootEventBus.setInfoSliderPageWArr, v => this.setPageWithArrow(v));
  }

  private addToCon = () => this.InfoSlider.addChild(this);
  calcBoundaryStatus() {
    const state = this.currPageIndex == 0 ? "first" : this.currPageIndex == this.infoSliderAssets.length - 1 ? "last" : "middle";
    rootEventBus.emit(EnumRootEventBus.updateEdgeState, state)
  }
  private addFrame() {
    const width = this.infoSliderDims.width;
    const height = this.infoSliderDims.height;
    const frame = new PIXI.Graphics()
      .roundRect(-this.infoSliderDims.width / 2, -this.infoSliderDims.height / 2, width, height, 10)
      .stroke({ color: 0x000000, width: 3 });
    this.addChild(frame);
  }
  private addMask() {
    const texture = TextureManager.getTexture(MASK_PATH);
    const mask = new PIXI.Sprite(texture)
    mask.width = this.infoSliderDims.width;
    mask.height = this.infoSliderDims.height;
    mask.anchor.set(.5);
    this.addChild(mask);
    this.Pages.mask = mask;
  }
  private addPages() {
    this.Pages = new PIXI.Container();
    this.addChild(this.Pages);

    this.infoSliderAssets.forEach((Asset, assetIndex) => {
      const slide = new InfoPage(Asset);

      slide.x = this.infoSliderDims.width * assetIndex;
      slide.y = 0;
      this.Pages.addChild(slide);
    })
  }
  private setPageWithArrow(v: 1 | -1) {
    const newPage = Math.min(this.infoSliderAssets.length - 1, Math.max(0, this.currPageIndex + v));
    this.setPage(newPage);
  }
  private setPage(pNumber: number) {
    const delta = Math.abs(pNumber - this.currPageIndex);
    this.currPageIndex = pNumber;
    const offsetX = this.infoSliderDims.width * (pNumber)
    const duration = 100 * delta;
    rootEventBus.emit(EnumRootEventBus.setCurPage, this.currPageIndex)
    new SlideAnimation(this.Pages, -offsetX, duration);
  }
}